module.exports = __webpack_public_path__ + "img/paper_plus.619d7919.svg";